import { useForm } from 'react-hook-form'

import { TYPES_SOURCE_OPTIONS } from '@constants'
import { FormCommand, GETCommand } from '@types'

import {
  convertFormCommandsToGETCommands,
  convertGETCommandsToFormCommands,
} from '../../../helpers/commandConverters'

export type AddCommandsDialogProps = {
  onCloseDialog: () => void
  onChangeCommands: (value?: GETCommand[] | null) => void
  commands?: GETCommand[] | null
}

const createEmptyFormCommand = (): FormCommand => ({
  internalId: Date.now().toString(),
  type: null,
  name: null,
  httpMethod: undefined,
  resource: undefined,
  objectCode: null,
  sourceCommand: null,
  sourceType: {
    id: TYPES_SOURCE_OPTIONS.OBJECT,
    label: TYPES_SOURCE_OPTIONS.OBJECT,
  },
  parameters: [],
  body: [],
})

export const useAddCommandsDialog = (props: AddCommandsDialogProps) => {
  const { commands, onCloseDialog, onChangeCommands } = props

  let formCommands = convertGETCommandsToFormCommands(commands)

  if (!formCommands || formCommands.length === 0) {
    formCommands = [createEmptyFormCommand()]
  }

  const methods = useForm<{ commands: FormCommand[] | null }>({
    defaultValues: {
      commands: formCommands,
    },
  })

  const { trigger, getValues } = methods

  const handleSave = () => {
    trigger().then(value => {
      if (value) {
        const { commands: formCommandsData } = getValues()

        // Convert FormCommand[] back to GETCommand[] before saving
        const getCommands = convertFormCommandsToGETCommands(formCommandsData)

        onChangeCommands(getCommands)
        onCloseDialog()
      }
    })
  }

  return {
    data: {},
    state: {
      methods,
    },
    handlers: {
      handleSave,
    },
  }
}
